import React, { useState, useEffect } from "react";
import Layouts from "../../../components/Layouts";
import { Typography, Spin, Button, Space } from "antd";
import { useSelector } from "react-redux";


import SupervisorSelect from "./SupervisorSelect";
import LoansTable from "../../loans_routes/loancreate/components/LoansTable";
import GeneralSerialsUpload from "../../loans_routes/loancreate/components/GeneralSerialsUpload";

import SerialsModal from "../../loans_routes/loancreate/components/SerialsModal";
import SummarySerialsModal from "../../loans_routes/loancreate/components/SummarySerialsModal";
import NotFoundSerialsModal from "../../loans_routes/loancreate/components/NotFoundSerialsModal";
import { useVendors } from "../hooks/useVendors";
import { useLoans } from "../hooks/useLoans";
import { useSerials } from "../hooks/useSerials";

const { Title } = Typography;

function TroopLoansRepay() {
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const { vendors, loadingVendors } = useVendors(userBodega);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);

  useEffect(() => {
    const found = vendors.find((v) => v.id === selectedVendorId);
    setSelectedVendor(found || null);
  }, [selectedVendorId, vendors]);

  const { loans, loadingLoans, getLoans } = useLoans(selectedVendor);

  useEffect(() => {
    if (selectedVendor) getLoans();
  }, [selectedVendor, getLoans]);

  const serials = useSerials({
    vendor: selectedVendor,
    loans,
    onLoansRefresh: getLoans,
    userBodega,
    isTropas: true,
  });

  return (
    <Spin
      spinning={serials.loadingGeneralSerials}
      tip="Procesando seriales..."
      size="large"
    >
      <Layouts>
        <Title level={4}>Devolver Seriales Prestados - Tropas</Title>
        <SupervisorSelect
          supervisors={vendors}
          loading={loadingVendors}
          onChange={setSelectedVendorId}
          value={selectedVendorId}
        />
        {selectedVendor && (
          <Spin spinning={loadingLoans} tip="Cargando préstamos...">
            <LoansTable
              loans={loans}
              loading={loadingLoans}
              onViewSerials={serials.onViewSerials}
              onReturnNotSerialized={serials.onReturnNotSerialized}
            />
          </Spin>
        )}
        {loans.length > 0 && (
          <Space direction="vertical" style={{ width: '100%', marginTop: 16 }}>
            <Button
              type="primary"
              size="large"
              onClick={serials.onReturnAllSerialized}
              loading={serials.loadingGeneralSerials}
              style={{ marginBottom: 16 }}
            >
              Devolver Todos los Productos Serializados
            </Button>
            <GeneralSerialsUpload
              onUpload={serials.onGeneralSerialsUpload}
              fileList={serials.generalFileList}
              setFileList={serials.setGeneralFileList}
              loading={serials.loadingGeneralSerials}
            />
          </Space>
        )}
        <SerialsModal
          visible={serials.modalSerials}
          onClose={serials.onCloseSerialsModal}
          serialsList={serials.serialsList}
          serialsPage={serials.serialsPage}
          pageSize={100}
          serialsTotal={serials.serialsTotal}
          onPageChange={serials.onSerialsPageChange}
        />
        <SummarySerialsModal
          visible={serials.modalSummaryVisible}
          onClose={serials.onCloseSummaryModal}
          summarySerials={serials.summarySerials}
        />
        <NotFoundSerialsModal
          visible={serials.modalNotFoundVisible}
          onClose={serials.onCloseNotFoundModal}
          notFoundSerialsList={serials.notFoundSerialsList}
          notFoundSerialsPage={serials.notFoundSerialsPage}
          notFoundSerialsPageSize={serials.notFoundSerialsPageSize}
          onPageChange={serials.setNotFoundSerialsPage}
        />
      </Layouts>
    </Spin>
  );
}

export default TroopLoansRepay;
